import React from 'react'
import Layout from './Layout';
import RealtimeData from './RealtimeData';

const HomePage = () => {

    return (
        <Layout>
            <RealtimeData />
        </Layout>
    )
}

export default HomePage
